<template>
  <div>
    <b-row>
      <b-col md="8">
        <b-row>
          <b-col>
            <dl>
              <dt>Site</dt>
              <dd>{{ site.name }}<br />
                {{ site.streetAddress }}<br />
                {{ site.city }}, {{ site.state }}<br />
                {{ site.zip }}<br />
              </dd>
              <dt>Contract Required</dt>
              <dd>{{ site.siteContractrequirement ? site.siteContractrequirement.name : null }}</dd>
            </dl>
          </b-col>
          <b-col>
            <dl>
              <dt>Website</dt>
              <dd><a :href="site.website" target="_blank">{{ site.website }}</a></dd>
              <dt>Phone</dt>
              <dd>{{ site.phone }}</dd>
              <dt>Fax</dt>
              <dd>{{ site.fax }}</dd>
            </dl>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-row>
              <b-col>
                <strong>Description</strong>
                <show-more :text="site.description" v-if="site.description"></show-more>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

      </b-col>
      <b-col md="4">
        <map-display :streetAddress="site.streetAddress" :state="site.state" :city="site.city" :zip="site.zip"
          v-if="hasAddress"></map-display>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import { mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import ShowMore from "../show-more";
import MapDisplay from "../../components/map-display";

export default {
  data() {
    return {};
  },

  components: {
    "show-more": ShowMore,
    "map-display": MapDisplay
  },

  props: {
    site: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),

    hasAddress: function () {
      return (
        this.site.streetAddress ||
        this.site.city ||
        this.site.state ||
        this.site.zip
      );
    }
  },

  methods: {
    // tells whether user can only see Viewer details
    onlyViewer: function () {
      return !_.find(this.user.userRoles, function (userRole) {
        return (
          userRole === "Placements.Admin" ||
          userRole === "Placements.ContractManager" ||
          userRole === "Placements.Advisor"
        );
      });
    }
  }
};
</script>

<style scoped></style>
